import { SessionStorageKeys } from './protocol.ts';
import type { OAuthCallbackParams } from './protocol.ts';
import type { ILocation, IBrowserStorage } from './types.ts';
import { noopLogger, type OAuthLogger } from './logger.ts';

export function generateState(): string {
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);
  return Array.from(array, b => b.toString(16).padStart(2, '0')).join('');
}

/** Cleanup session storage used by the OAuth flow. */
export function cleanupSessionStorage(
  storage: IBrowserStorage = window.sessionStorage,
  logger: OAuthLogger = noopLogger,
): void {
  try {
    storage.removeItem(SessionStorageKeys.OpenerOrigin);
    storage.removeItem(SessionStorageKeys.State);
  } catch (e) {
    logger.warn('Failed to cleanup OAuth session storage', e);
  }
}

/** Extract OAuth callback params from the current page's query string. */
export function getOAuthCallbackParams(location: ILocation = window.location): OAuthCallbackParams {
  const params = new URLSearchParams(location.search);
  return {
    code: params.get('code') ?? undefined,
    state: params.get('state') ?? undefined,
    error: params.get('error') ?? undefined,
  };
}
